import { createApp } from 'vue';
import { initGapi, gapiOnLoad } from '@/services/gapi';
import { googleMapsApiOnLoad } from '@/services/maps';
import store from './store';
import App from './App.vue';
import router from './router';
import { useFirebaseAuth } from './services';

const { ensureFirebaseInit } = useFirebaseAuth();

const initApp = () => createApp(App).use(store.original).use(router).mount('#app');

Promise.all([gapiOnLoad(), googleMapsApiOnLoad()]).then(async () => {
  await initGapi();
  await ensureFirebaseInit();
  initApp();
});
